import { erStatic } from '../static-all';
import { reduceToMap } from '$lib/utils/array';
import type { TranslationFunctions, Translations } from '$i18n/i18n-types';
import { immediateDerived } from '$lib/store';
import type ERAR from '$lib/erar/spec';

export const idToCreditEvent = immediateDerived(
  erStatic,
  (values) => {
    return reduceToMap(
      values?.result.creditEvents ?? [],
      (v) => v.id,
      (v) => v,
    );
  },
  new Map<number, ERAR.Schema.StaticCreditEventList[number]>(),
);

export function getCreditEventName(LL: TranslationFunctions, name: string): string {
  type Key = keyof Translations['creditEvents'];
  if (name in LL.creditEvents) {
    return LL.creditEvents[name as Key]();
  }
  return name;
}
